<template>
  <v-container
    v-show="viewPage"
    fluid
  >
    <div class="text-h2">
      Mis órdenes
    </div>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="10"
      >
        <v-card>
          <v-data-table
            :headers="headers"
            :items="students"
            :hide-default-footer="true"
          >
            <template v-slot:[`item.actions`]="{ }" />
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <help-button
      :tutorial="tutorial"
    />
  </v-container>
</template>

<script>
  import firebase from 'firebase'
  import { mapState } from 'vuex'
  import HelpButton from '@/views/dashboard/pages/panel/HelpButton'

  export default {
    components: {
      HelpButton,
    },
    data () {
      return {
        viewPage: false,
        tutorial: 'shop-my-products',
        uid: '',
        students: [],
        headers: [
          { text: 'Orden', value: 'order_id' },
          { text: 'Descripción', value: 'name' },
          { text: 'Fecha', value: 'date' },
          { text: 'Precio', value: 'price' },
        ],
      }
    },
    computed: {
      ...mapState(['user']),
    },
    mounted () {
      this.uid = this.user.uid
      this.init()
    },
    methods: {
      init () {
        const currentUser = firebase.auth().currentUser
        this.uid = currentUser.uid
        this.loadOrders()
      },
      loadOrders () {
        this.loading = true
        this.loadingOrders = true
        firebase
          .firestore()
          .collection('orders')
          .where('uid', '==', this.uid)
          .get()
          .then(response => {
            var documents = response.docs
            const orders = []
            documents.forEach(document => {
              const data = document.data()
              const date = firebase.firestore.Timestamp.now()
                .toDate()
                .toDateString()
              const order = {
                order_id: data.orderID,
                name: data.product_name,
                date: date,
                price: data.price,
              }
              orders.push(order)
            })
            this.students = orders
          })
          .catch(error => {
            console.log(error)
            alert(error)
          })
      },
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        const user = vm.user
        if (user.type === 'tutor' || user.type === 'parent') {
          vm.viewPage = true
          next()
        } else {
          console.log('Está intentando ingresar a una pagina no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
  }
</script>
